export function AdEntryPointBoxConstructor(services, type) {

  const joint = services.joint;
  let label;
  switch (type) {
    case 'html.ClickToMessengerBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/click_to_messenger_box_title_in_diagram');
      break;
    case 'html.SponsoredBzcMessageBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/sponsored_bzc_message_box_title_in_diagram');
      break;
    case 'html.LineRichMenuBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/line_rich_menu_box_title_in_diagram');
      break;
   }

  const defaults = joint.util.deepSupplement({
    'labelText': label,
    'type': type,
  }, joint.shapes.html.GetStartedBox.prototype.defaults);

  return joint.shapes.html.GetStartedBox.extend({
    defaults: defaults
  });

}
